'use client'
import { forwardRef, HTMLAttributes, PropsWithChildren } from 'react'
import { Splide, SplideProps } from '@splidejs/react-splide'
import '@splidejs/react-splide/css'
import { clsx } from 'clsx'

export type CarouselProps = PropsWithChildren<
  HTMLAttributes<Splide> & SplideProps & { hasCustomTrack?: boolean }
>

export const Carousel = forwardRef<Splide, CarouselProps>(
  ({ children, options, className, hasCustomTrack }, ref) => {
    return (
      <Splide
        ref={ref}
        hasTrack={!hasCustomTrack}
        tag="div"
        options={{
          fixedHeight: 150,
          arrows: false,
          pagination: false,
          gap: '.75rem',
          role: 'group',
          breakpoints: {
            500: {
              drag: true,
              perPage: 1,
              padding: { right: '10%' },
              fixedWidth: undefined,
            },
          },
          ...options,
        }}
        className={clsx('', className)}
      >
        {children}
      </Splide>
    )
  },
)
Carousel.displayName = 'Carousel'
